import { call, put, take, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { api } from 'services';
import {
	getRefundsRequest,
	getRefundsSuccess,
	getRefundsForFilterIdRequest,
	getRefundsForFilterIdSuccess,
	getRefundRequest,
	getRefundSuccess,
	getRefundBreakdownRequest,
	getRefundBreakdownSuccess,
} from './reducer';
import {
	TRefundsRequest,
	TRefundsResponsePayload,
	TRefundBreakdownRequest,
	TRefundBreakdownResponsePayload,
} from './types';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

function* getRefundsRequestWorker(action: PayloadAction<TRefundsRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TRefundsResponsePayload = yield call(api.refunds.getRefunds, payload);
		yield put(getRefundsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

function* getRefundsForFilterIdRequestWorker(action: PayloadAction<TRefundsRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TRefundsResponsePayload = yield call(api.refunds.getRefunds, payload);
		yield put(getRefundsForFilterIdSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

function* getRefundRequestWorker(action: PayloadAction<TRefundsRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TRefundsResponsePayload = yield call(api.refunds.getRefunds, payload);
		yield put(getRefundSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

function* getRefundBreakdownRequestWorker(action: PayloadAction<TRefundBreakdownRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TRefundBreakdownResponsePayload = yield call(
			api.refunds.getRefundBreakdown,
			payload,
		);
		yield put(getRefundBreakdownSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

export function* refundsSaga() {
	yield takeEvery(getRefundsRequest.type, getRefundsRequestWorker);
	yield takeEvery(getRefundsForFilterIdRequest.type, getRefundsForFilterIdRequestWorker);
	yield takeEvery(getRefundRequest.type, getRefundRequestWorker);
	yield takeEvery(getRefundBreakdownRequest.type, getRefundBreakdownRequestWorker);
}
